export default {
  insurance: {
    id: 'insurance_add_to_cart_page_label',
    defaultMessage: 'Protection Plan',
  },
}
